import axios from 'axios';
import authHeader from './auth-header';

const API_URL = process.env.REACT_APP_URL_API;

class PaymentService {
    getPayments(agentId) {
        return axios.get(API_URL + 'payments/' + agentId, { headers: authHeader() });
    }

    getAllPayments(service) {
        let urlListePayment = "";
        if(service ==="Tous"){
            urlListePayment = "payments_wls";
        }else if(service==="B2C"){
            urlListePayment = "payments_wls?name_prefix=CM_CT_PM_PT";
        }else{
            urlListePayment = "payments_wls?name_prefix=NOT_CM_CT_PM_PT";
        }
        return axios.get(API_URL + urlListePayment , { headers: authHeader() });
    }

    getIframeWorldline() {
        return axios.get(API_URL + 'worldline/iframe', { headers: authHeader() });
    }
    addPayment(username, email, password) {
        return axios.post(API_URL + "payments", {
            username,
            email,
            password
        },{ headers: authHeader() });
    }

    startProcess(contractRef, customerRef, user, origine, pp1, paymentCancelledAndPdl,anticipated){
        return axios.post(API_URL + "process/start", {
            contractRef,
            customerRef,
            user,
            origine,
            pp1,
            paymentCancelledAndPdl,
            anticipated
        },{ headers: authHeader() });
    }

    startProcessEnedis(customerRef, contractRef, user, affairId, typeRequest, origin,pce){
        return axios.post(API_URL + "process_enedis/start", {
            customerRef,
            contractRef,
            user,
            affairId,
            typeRequest,
            origin,
            pce
        },{ headers: authHeader() });
    }

    startProcessGrd(customerRef, contractRef, user, affairId, typeRequest, origin,pce){
        return axios.post(API_URL + "process_grdf/start", {
            customerRef,
            contractRef,
            user,
            affairId,
            typeRequest,
            origin,
            pce
        },{ headers: authHeader() });
    }


    updateProcessEnedis(processId,tel,dateEffet){
        return axios.put(API_URL + "process_enedis/"+processId, {
            tel,
            dateEffet,
        },{ headers: authHeader() });
    }

    updateProcessGrdf(processId,tel,dateEffet){
        return axios.put(API_URL + "process_grds/"+processId, {
            tel,
            dateEffet
        },{ headers: authHeader() });
    }

    executProcessEnedis(processEnedisId){
        return axios.post(API_URL + "process_enedis_action", {
            processEnedisId
        },{ headers: authHeader() });
    }

    executProcessGrdf(processGrdfId){
        return axios.post(API_URL + "process_grdf_action", {
            processGrdfId
        },{ headers: authHeader() });
    }


    getPayment(paymentId){
        return axios.get(API_URL + 'payments/' + paymentId, { headers: authHeader() });
    }

    getListPayment(processId){
        return axios.get(API_URL + 'payments/list/' + processId, { headers: authHeader() });
    }

    getAllListPaymentWl(contract_ref, customer_ref){
        return axios.post(API_URL + "payments/wl/list" , {
            contract_ref,
            customer_ref
        },{ headers: authHeader() });
    }

    refundPaymentWl(contract_ref, customer_ref, payment_id, amount, comment,refund_name){
        return axios.post(API_URL + "payment/wl/refund" , {
            contract_ref,
            customer_ref,
            payment_id,
            amount,
            comment,
            refund_name
        },{ headers: authHeader() });
    }


    deletePayment(paymentId){
        return axios.delete(API_URL + "payments/" + paymentId, { headers: authHeader() });
    }

    updatePayment(paymentId, username, email, password){
        return axios.put(API_URL + "payments/" + paymentId, {
            username,
            email,
            password
        },{ headers: authHeader() });
    }

    getInfoSpread(customerRef, contractRef, status, dettes){
        return axios.get(API_URL + 'infospread/' + customerRef + "/" + contractRef + "/" + status + "/" + dettes, { headers: authHeader() });
    }

    getInfoSpreadAnticipated(customerRef, contractRef, status, listinvoice, listinvoiceselect, dettes){
        return axios.post(API_URL + 'infospreadanticipated', {
            customerRef,
            contractRef,
            status,
            listinvoice,
            listinvoiceselect,
            dettes
        },{ headers: authHeader() });

    }

    getInfoAmountPP1(customerRef, contractRef){
        return axios.get(API_URL + 'contract/pp1/' + customerRef + "/" + contractRef, { headers: authHeader() });
    }

}

export default new PaymentService();
